<template>
	<v-card class='comment-form-container mt-5 elevation-0'>
		<v-form
			ref='form'
			v-model='valid'
			lazy-validation
			@submit.prevent='validateAndSubmit'
		>
			<div class='d-flex comment-form__text-outer'>
				<router-link
					:to="{ name: 'profile-pre-view'}"
					class="d-flex align-center text-decoration-none"
				>
					<Avatar
						class='mr-6 mt-2 mb-3' size='50'
						:avatar='this.$props.avatar'
					/>
				</router-link>

				<div class='d-flex align-center' style='width: 100%;'>
					<v-textarea
						class='comment-form__textarea custom-textarea mr-4'
						label='Write a comment ...' rows='1'
						:value='fields.content'
						v-model='fields.content'
						:error-messages='field_errors.content'
						:rules='rules.content'
						required
					></v-textarea>
					<v-btn
						:loading='loading' border='false' elevation='0'
						@click='validateAndSubmit'
						class='comment-form__button'
					>
						Send
					</v-btn>
				</div>
			</div>
			<p v-for='(index, error) in errors' :key='index' class='red--text'>
				{{ error }}
			</p>
		</v-form>
		<CommentMentionBar 
			v-if="isMentionActive" 
			:searchString="fields.content" 
			:mentions="mentions" 
			@setMention="setMention"
		/>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from '@/mixins/Form'
import { ruleRequired } from '@/utils/rules'
import Avatar from '@/components/Avatar'
import CommentMentionBar from '@/components/CommentMentionBar.vue'

export default {
	name: 'CommentForm',
	components: {
		Avatar,
		CommentMentionBar
	},
	mixins: [Form],
	props: {
		isReply: {
			type: Boolean,
			default: false,
		},
		parent: {
			type: Object,
			default: () => {
			},
		},
		isEdit: {
			type: Boolean,
			default: false,
		},
		comment: {
			type: Object,
			default: () => {
			},
		},
		avatar: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		fields: {
			content: '',
		},
		mentions: []
	}),
	methods: {
		...mapActions('post', { postAddComment: 'addComment' }),
		...mapActions('forum', { forumAddComment: 'addComment' }),

		isCurrentUser(userId) {
			if (!this.profile) {
				return false
			}

			const {user_id: currentUserId} = this.profile
			return userId === currentUserId;
		},

		submitForm() {
			this.field_errors = {}

			let result = this.fields.content
			
			this.mentions.forEach(item => {
				const startIndex = result.indexOf(item.visible_username.replace(' ', '')) - 1
				if (startIndex >= 0) {
					const endIndex = item.visible_username.replace(' ', '').length + startIndex + 1
					result = result.substring(0, startIndex) + `@[${item.user_id}|${item.visible_username}]` + result.substring(endIndex)
				}
			})

			this.mentions = []
			if (this.parent.thread_id) {
				return this.postAddComment({
					thread_id: this.parent.thread_id || this.parent.forum_id,
					reply_text: result,
				})
			}

			if (this.parent.forum_id) {
				return this.forumAddComment({
					thread_id: this.parent.thread_id || this.parent.forum_id,
					reply_text: result,
				})
			}

			return this.forumAddComment({
				thread_id: this.parent.thread_id || this.parent.forum_id,
				reply_text: result,
			})
		},
		setMention(user, number) {
			const splittedContent = this.fields.content.split('@')
			splittedContent[number + 1] = user.visible_username.replace(' ', '')
			this.mentions[number] = user
			this.fields.content = splittedContent.join('@')
		}
	},
	computed: {
		...mapGetters('auth', ['isAuthenticated', 'profile']),
		...mapGetters('post', ['isCommentAdding']),
		...mapGetters('forum', ['isForumCommentAdding']),

		rules() {
			return {
				content: [
					v => ruleRequired(v) || 'Field is required.',
					v => !!v.trim().length || 'Text cannot be empty'
				],
			}
		},
		isMentionActive() {
			return this.fields.content && 
			!this.isCommentAdding && 
			!this.isForumCommentAdding &&
			this.fields.content.split('@').length > 1 + this.mentions.length
		}
	},
	watch: {
		'fields.content': {
			handler() {
				if (this.fields.content) {
					const splittedContent = this.fields.content.split('@')
					splittedContent.forEach((item, index) => {
						if (index > 0 && this.mentions[index - 1] && !item.startsWith(this.mentions[index - 1].visible_username.replace(' ', ''))) {
							this.mentions.splice(index - 1, 1)
							if (splittedContent[index].split(' ')[1]) {
								splittedContent[index - 1] = splittedContent[index - 1] + splittedContent[index].split(' ')[1]
							}
							splittedContent.splice(index, 1)
							this.fields.content = splittedContent.join('@')
						}
					})
				}
			}
		}
	}
}
</script>

<style scoped lang='scss'>
.comment-form-container, .comment-form {
	font-family: Montserrat, sans-serif;
	position: relative;

	font-style: normal;
	font-weight: 500;
	font-size: 20px;
	line-height: 24px;
	letter-spacing: 0.5px;

	&__textarea {
		color: #4a4a4a;
		background-color: transparent;
		box-shadow: none;

		&:focus {
			.v-input__slot {
				border: 1px solid #000000;
			}
		}
	}

	&__button {
		background-color: var(--accent-color) !important;
		color: white !important;
		border: none;
	}

	@media screen and (max-width: 400px) {
		&__text-outer {
			flex-direction: column;
		}
	}
}

.custom-textarea .v-text-field--is-disabled .v-label {
	display: none;
}

</style>
